exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-sources-datatable {\n  word-wrap: break-word; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-media-sources/components/project-media-sources/project-media-sources.component.scss
// module id = ../../../../../src/app/modules/models/project-media-sources/components/project-media-sources/project-media-sources.component.scss
// module chunks = main